import { render, staticRenderFns } from "./OrderProductCard.vue?vue&type=template&id=0112533f&"
import script from "./OrderProductCard.vue?vue&type=script&lang=js&"
export * from "./OrderProductCard.vue?vue&type=script&lang=js&"
import style0 from "./OrderProductCard.vue?vue&type=style&index=0&id=0112533f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ImageProduct: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/ImageProduct.vue').default})
